import React from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';
import { FormFooter } from '@Components/happyFlowTemplate/FormFooter.tsx';
import { ExtendedUseFormReturn } from '@Hooks/index';
import { FieldValues } from 'react-hook-form';
import { useBoundStore } from '@Store/useBoundStore';
import { twMerge } from 'tailwind-merge';

interface IStepPageWrapper<T extends FieldValues> {
  heading?: string;
  content?: string;
  children: React.ReactNode;
  isLoading?: boolean;
  handleSubmit?: () => void;
  formMethods?: ExtendedUseFormReturn<T>;
  maxWidth?: number;
  customBackHandling?: () => void;
  customSubmitTitle?: string;
  footerInputSlot?: React.ReactNode;
  shouldStrechCta?: boolean;
}

export const StepPageWrapper = <T extends FieldValues>(props: IStepPageWrapper<T>) => {
  const { isLoading = false, handleSubmit } = props;
  const isEmbedded = useBoundStore((state) => state.onboardingSlice.getIsEmbedded());

  const layoutStyle = twMerge(
    'grow w-full h-full flex justify-center items-start overflow-y-scroll px-[16px] md:px-[24px]',
    isEmbedded ? 'py-[24px] md:pt-[64px]' : 'pb-[24px] pt-[24px] md:pt-[127px]'
  );

  return (
    <div
      className='flex flex-col w-full h-full responsive-content justify-between items-center fade-in overflow-hidden'
      id='page-wrapper'>
      <div className={layoutStyle} id='page-layout'>
        <div
          style={{ maxWidth: props.maxWidth ? `${props.maxWidth}px` : '500px' }}
          className='flex flex-col w-full '
          id='page-content'>
          <div className='flex flex-col'>
            {props.heading && (
              <Heading.H5 fontWeight={FontWeight.SEMIBOLD}>{props.heading}</Heading.H5>
            )}
            {props.content && (
              <Text.H9 className='text-text-main-secondary whitespace-pre-line mb-[24px] mt-[8px]'>
                {props.content}
              </Text.H9>
            )}
          </div>
          {props.children}
        </div>
      </div>
      {props.formMethods && (
        <FormFooter
          footerInputSlot={props.footerInputSlot}
          customSubmitTitle={props.customSubmitTitle}
          formMethods={props.formMethods}
          maxWidth={props.maxWidth}
          isLoading={isLoading}
          onSubmit={() => (handleSubmit ? handleSubmit() : null)}
          customBackHandling={props.customBackHandling}
          shouldStrechCta={props.shouldStrechCta}
        />
      )}
    </div>
  );
};
